<template>
    <inertia-link :href="href" :class="classes">
        <slot></slot>
    </inertia-link>
</template>

<script>
    export default {
        //props: ['href', 'active', ''],
        props: {
            href: {
                default: "#"
            },
            active: {
                default: false
            },
            active_classes: {
                default: "border-birdie-blue focus:border-birdie-blue"
            },
        },
        computed: {
            classes() {
                var classes = "inline-flex items-center px-1 pt-1 border-b-4 font-medium leading-5  focus:outline-none transition "
                if (this.active) {
                    classes += this.active_classes
                } else {
                    classes += 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300'
                }
                return classes
            }
        }
    }
</script>
